import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiFillInstagram,
  AiFillFacebook
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Made  by  Muhammad Ismaeel</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} MI</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/muhammad-ismaeel-9"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>
            <li className="social-icons">
                <a
                style={{textDecoration:"none" ,color: "white"  }}
                href="mailto:m.ismaeel.dev@gmail.com"
                  className=""
                  title="Email me at m.ismaeel.dev@gmail.com"
                >
                 <span style={{fontSize:"16px" , fontWeight:"700", }} className=" ">G </span>
                </a>
              </li>
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/muhammad-ismaeel-461355251"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.instagram.com/ism_4_9"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillInstagram />
              </a>
            </li>
            <li className="social-icons">
                <a
                 style={{ color: "white" }}
                  href="https://www.facebook.com/muhammad.ismaeel.76"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AiFillFacebook />
                </a>
              </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
